/* AFTERMILE fixed release: 2026-10-24 15:00 America/New_York (UTC-04), 19:00 UTC. Display-only gate; Shopify publication/password governs commerce. */
(function(){
 "use strict";
 var launchMs=Date.parse("2026-10-24T15:00:00-04:00");
 if(!Number.isFinite(launchMs))return;
 function fmt(n){return String(n).padStart(2,"0")}
 function update(root){
   var left=Math.max(0,launchMs-Date.now());
   var s=Math.ceil(left/1000);
   var values={days:Math.floor(s/86400),hours:Math.floor(s%86400/3600),minutes:Math.floor(s%3600/60),seconds:s%60};
   Object.keys(values).forEach(function(k){var el=root.querySelector('[data-aml26-unit="'+k+'"]');if(el){var value=fmt(values[k]);if(el.textContent!==value)el.textContent=value}});
   if(left<=0&&!root.classList.contains("is-open")){
     root.classList.add("is-open");
     var status=root.querySelector("[data-aml26-status]");
     if(status)status.textContent="3:00 PM Eastern has arrived.";
     if(root.getAttribute("data-aml26-refresh")==="true"){
       var url=new URL(window.location.href);
       if(!url.searchParams.has("aftermile_launch")){
         url.searchParams.set("aftermile_launch","20261024");
         window.location.replace(url.toString());
       }
     }
   }
 }
 function start(){
   document.querySelectorAll("[data-aml26-countdown]").forEach(function(root){
     update(root);
     window.setInterval(function(){update(root)},200);
     document.addEventListener("visibilitychange",function(){if(!document.hidden)update(root)});
   });
 }
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
})();